import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { convertDaysToTimeUnit } from 'support/helpers/dateTime/dateTime';
import { OrderFormProductDTO } from 'support/types/dtos';

export const useProductAttributes = (product: OrderFormProductDTO) => {
  const { t } = useTranslation();

  return useMemo(() => {
    const attributeList = [];

    const numberOfDays = Math.floor(Number(product.minimum_remaining_shelf_life));
    if (numberOfDays) {
      const { quantity, unit: timeUnit } = convertDaysToTimeUnit(numberOfDays);

      const unitTranslations = {
        day: t('orderForms:form.product.timeUnits.day', { count: quantity }),
        week: t('orderForms:form.product.timeUnits.week', { count: quantity }),
        month: t('orderForms:form.product.timeUnits.month', { count: quantity }),
        year: t('orderForms:form.product.timeUnits.year', { count: quantity }),
      };

      const unit = unitTranslations[timeUnit as keyof typeof unitTranslations];
      attributeList.push(
        t('orderForms:form.product.minimumShelfLife', {
          value: quantity,
          unit,
        }),
      );
    }

    return attributeList;
  }, [product, t]);
};
